import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function putUsersConvertToPassport(users : Array<{id : number}>) : Promise<void> {
    const { apiPutUsersConvertToPassport } = apiConfig.getStaticUrls();

    return postFetch(`${apiPutUsersConvertToPassport}`, {
        users: users,
    });
}
